import React, { useState } from "react";

// Components
import { IonLabel, IonSegment, IonSegmentButton, IonSpinner, IonToggle } from "@ionic/react";

// Hooks and Services
import { useTranslation } from "react-i18next";
import { ApiService } from "../../../services";

// Styles
import "./Sidebar.scss";

export interface SidebarProps {
  visible?: boolean;
  tabs: { [key: string]: SidebarTab } | null;
  onTabChange?(): void;
  className?: string;
}

export interface SidebarTab {
  label: string;
  stageIds: number[];
  requiresReview: boolean;
  component: JSX.Element;
  visible: boolean;
}

const Sidebar: React.FC<SidebarProps> = (props) => {
  const [activeTab, setActiveTab]: [any, any] = useState(0);
  const { className, tabs, visible } = props;
  const { t } = useTranslation();

  if (!visible) return null;

  return (
    <div className={`sidebar registration-sidebar ${className && className}`}>
      <h2>{t("forms")}</h2>

      {/* @ts-ignore */}
      {tabs.length > 0 ? (
        <>
          <IonSegment value={activeTab} scrollable={true} swipeGesture={true} onIonChange={(e) => setActiveTab(e.detail.value)}>
            {/* @ts-ignore */}
            {Object.keys(props.tabs).map((key, i) => {
              const tab = props.tabs![key];

              return (
                tab?.visible && (
                  <IonSegmentButton key={i} value={key}>
                    <IonLabel>{tab.label}</IonLabel>
                  </IonSegmentButton>
                )
              );
            })}
          </IonSegment>

          <div className="registration-sidebar__verify-stage">
            <span>{t("stageRequiresReview")}: </span>
            <IonToggle className="input__toggle" checked={tabs?.[activeTab]?.requiresReview} mode="md" onIonChange={toggleStageVerification} />
          </div>
        </>
      ) : (
        <IonSpinner name="dots" />
      )}

      <div>{props?.tabs?.[activeTab!]?.component}</div>
    </div>
  );

  function toggleStageVerification(event: any) {
    // @ts-ignore
    const { stageIds } = tabs?.[activeTab];
    const isChecked = event.target.checked;

    ApiService.post("register/stages/toggle-requires-review", { stages: stageIds, requires_review: isChecked });
  }
};

Sidebar.defaultProps = { visible: true };

export default Sidebar;
